// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Level3 extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Matérias</title>
        <desc>Representação de 3 níveis de informação</desc>
        <g id="icon-level3">
          <path d="M15,14H2V11h9a1,1,0,0,0,0-2H2V6H7A1,1,0,0,0,7,4H2V1A1,1,0,0,0,0,1V15a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2Z" />
        </g>
      </svg>
    );
  }
}

export default Level3;
